import { render, staticRenderFns } from "./DuplicateEnquiries.vue?vue&type=template&id=0c6166a4&scoped=true"
import script from "./DuplicateEnquiries.vue?vue&type=script&lang=js"
export * from "./DuplicateEnquiries.vue?vue&type=script&lang=js"
import style0 from "./DuplicateEnquiries.vue?vue&type=style&index=0&id=0c6166a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6166a4",
  null
  
)

export default component.exports